import { render, staticRenderFns } from "./ProjectBidSummary.vue?vue&type=template&id=82a618b2&scoped=true"
import script from "./ProjectBidSummary.vue?vue&type=script&lang=js"
export * from "./ProjectBidSummary.vue?vue&type=script&lang=js"
import style0 from "./ProjectBidSummary.vue?vue&type=style&index=0&id=82a618b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a618b2",
  null
  
)

export default component.exports